<h1 mat-dialog-title>Konto Löschen</h1>
<div mat-dialog-content *ngIf="!isLoading">
    <ng-container *ngIf="isSoleAdminInAnyOrg; else normalDeleteFlow">
        <div>
            <mat-error class="error-hint">
                Ihr Konto kann nicht gelöscht werden, da Sie der einzige Administrator in folgenden Organisationen sind:
            </mat-error>
            <div *ngFor="let org of isSoleAdminInOrg" class="org-item">
                <p><strong>{{ org.organisationName }}</strong></p>
            </div>
            <!-- <p>
                Ernennen Sie einen Benutzer zum Administrator oder kontaktieren Sie den Support für weitere Hilfe.
            </p> -->
        </div>
    </ng-container>

    <ng-template #normalDeleteFlow>
        <ng-container *ngIf="decisions.length > 0; else noConfirmedOrgs">
            <p class="dialog-text">
                Um Ihr Konto zu löschen müssen Sie zunächst entscheiden, was mit den von
                Ihnen administrierten Organisation passieren soll.
            </p>

            <div *ngFor="let orgToDecide of decisions" class="memberShipDecisionTable">
                <p><strong>{{ orgToDecide.organisationName }}</strong></p>
                <p>Organisation übertragen an:</p>
                <!-- <mat-button-toggle-group
                    (change)="onSelectionChange($event, orgToDecide.organisationId)"
                    [disabled]="
                        orgToDecide.organisationMembers == null ||
                        orgToDecide.organisationMembers.length === 0
                    "
                    [value]="orgToDecide.selectedAction"
                >
                    <mat-button-toggle value="TRANSFER">Übertragen</mat-button-toggle>
                    <mat-button-toggle value="DELETE">Löschen</mat-button-toggle>
                </mat-button-toggle-group> -->
                <!-- <div *ngIf="orgToDecide.selectedAction == 'TRANSFER'; else reason"> -->
                <div>
                    <mat-form-field appearance="standard">
                        <mat-label>Benutzer wählen</mat-label>
                        <mat-select (selectionChange)="
                            onTransferSelectionChange($event, orgToDecide.organisationId)
                        "><mat-option *ngFor="let member of orgToDecide.organisationMembers"
                                [value]="member.userName">{{ member.userName }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <!-- <ng-template #reason>
                    <p class="reason">
                        {{
                            orgToDecide.organisationMembers == null ||
                            orgToDecide.organisationMembers.length === 0
                                ? orgToDecide.reason
                                : ''
                        }}
                    </p>
                </ng-template> -->
            </div>
        </ng-container>

        <ng-template #noConfirmedOrgs>
            <p class="dialog-text">
                Möchten Sie Ihr Konto wirklich löschen?
            </p>
        </ng-template>

        <div *ngIf="leftOrganisations.length > 0">
            <h3>Zusätzlich werden die folgenden Organisationen verlassen</h3>
            <div *ngFor="let leftOrganisation of leftOrganisations" class="leftOrganisations">
                <p>{{ leftOrganisation.organisationName }}</p>
                <p>{{ leftOrganisation.reason }}</p>
            </div>
        </div>
    </ng-template>

</div>

<div mat-dialog-content *ngIf="isLoading">
    <mat-spinner diameter="40"></mat-spinner>
</div>

<div mat-dialog-actions>
    <button [disabled]="hasIncompleteTransfer() || isSoleAdminInAnyOrg" mat-raised-button (click)="onClick(true)"
        class="btn_green">
        Bestätigen
    </button>
    <button mat-raised-button (click)="onClick(false)" class="btn_red">
        Abbrechen
    </button>
</div>